import { css } from 'styled-components'

export type ButtonBaseProps = {
  $isLoading: boolean
}

const primaryCSS = css<ButtonBaseProps>`
  background-color: ${({ $isLoading, theme }) =>
    $isLoading ? theme?.color?.hover?.primary : theme?.color?.status?.primary};
  color: ${({ theme }) => theme?.color?.neutral?.color11};

  &:hover {
    background-color: ${({ theme }) => theme?.color?.hover?.primary};
  }

  &:hover,
  &:focus {
    color: ${({ theme }) => theme?.color?.neutral?.color11};
  }

  &:active {
    background-color: ${({ theme }) => theme?.color?.press?.primary};
    color: ${({ theme }) => theme?.color?.neutral?.color11};
  }

  &:disabled {
    background-color: ${({ theme }) => theme?.color?.neutral?.color8};
    color: ${({ theme }) => theme?.color?.neutral?.color6};

    border: none;
  }
`

const defaultCSS = css<ButtonBaseProps>`
  color: ${({ theme }) => theme?.color?.neutral?.color3};
  background-color: ${({ theme }) => theme?.color?.neutral?.color11};

  border-color: ${({ theme }) => theme?.color?.neutral?.color6};

  &:hover,
  &:active {
    border-color: ${({ theme }) => theme?.color?.hover?.primary};
    color: ${({ theme }) => theme?.color?.hover.primary};
  }

  &:active {
    border-color: ${({ theme }) => theme?.color?.hover.primary};
    color: ${({ theme }) => theme?.color?.hover.primary};
  }

  &:disabled {
    background-color: ${({ theme }) => theme?.color?.neutral.color8};
    border-color: ${({ theme }) => theme?.color?.neutral.color6};
    color: ${({ theme }) => theme?.color?.neutral.color6};
  }
`

const textCSS = css<ButtonBaseProps>`
  padding: 0px;
  color: ${({ theme }) => theme?.color?.status?.primary};

  &:hover,
  &:focus {
    color: ${({ theme }) => theme?.color?.hover?.primary};
  }

  &:active {
    color: ${({ theme }) => theme?.color?.hover?.primary};
  }

  &:disabled {
    color: ${({ theme }) => theme?.color?.neutral?.color6};
  }
`

const textDangerCSS = css<ButtonBaseProps>`
  padding: 0px;
  color: ${({ theme }) => theme?.color?.status?.danger};

  &:hover,
  &:focus,
  &:active {
    color: ${({ theme }) => theme?.color?.status?.danger};
  }

  &:hover {
    opacity: 0.8;
  }
`

const dangerCSS = css<ButtonBaseProps>`
  background-color: ${({ $isLoading, theme }) =>
    $isLoading ? theme?.color?.hover.danger : theme?.color?.status.danger};
  color: ${({ theme }) => theme?.color?.neutral.color11};

  &:hover {
    background-color: ${({ theme }) => theme?.color?.hover.danger};
    color: ${({ theme }) => theme?.color?.neutral.color11};
  }

  &:focus {
    color: ${({ theme }) => theme?.color?.neutral.color11};
  }

  &:active {
    background-color: ${({ theme }) => theme?.color?.press.danger};
    color: ${({ theme }) => theme?.color?.neutral.color11};
  }

  &:disabled {
    background-color: ${({ theme }) => theme?.color?.neutral.color8};
    color: ${({ theme }) => theme?.color?.neutral.color11};
    border-color: ${({ theme }) => theme?.color?.neutral.color6};
  }
`

const popoutCSS = css<ButtonBaseProps>`
  background-color: ${({ $isLoading, theme }) =>
    $isLoading ? theme?.color?.hover.popout : theme?.color?.status.popout};
  color: ${({ theme }) => theme?.color?.neutral.color11};

  &:hover {
    color: ${({ theme }) => theme?.color?.neutral.color11};
    background-color: ${({ theme }) => theme?.color?.hover.popout};
  }

  &:focus {
    color: ${({ theme }) => theme?.color?.neutral.color11};
  }

  &:active {
    color: ${({ theme }) => theme?.color?.neutral.color11};
    background-color: ${({ theme }) => theme?.color?.press.popout};
  }

  &:disabled {
    background-color: ${({ theme }) => theme?.color?.neutral.color8};
    color: ${({ theme }) => theme?.color?.neutral.color11};
    border-color: ${({ theme }) => theme?.color?.neutral.color6};
  }
`

export const buttonTypes = {
  primary: primaryCSS,
  default: defaultCSS,
  text: textCSS,
  textDanger: textDangerCSS,
  danger: dangerCSS,
  popout: popoutCSS
}
